module.exports = __webpack_public_path__ + "static/media/top.07c652e2.svg";